import axios from 'axios';

const API_BASE_URL = 'https://explorer.menelik.cc/api';

export const fetchAddressData = async (address) => {
  try {
    const response = await axios.get(`${API_BASE_URL}/address/${address}`);
    return response.data.length > 0 ? response.data[0] : null;
  } catch (error) {
    console.error(`Error fetching address data for ${address}:`, error);
    return null;
  }
};

export async function fetchTableRecords() {
  try {
    const response = await fetch(`${API_BASE_URL}/table-records`);
    if (!response.ok) throw new Error('Failed to fetch table records');
    return await response.json();
  } catch (error) {
    console.error(error);
    return null;
  }
}

export const getSmartnodeLockedCoins = async () => {
  try {
      const response = await axios.get(`${API_BASE_URL}/getSmartnodeLockedCoins`);
      return response.data;
  } catch (error) {
      console.error('Error fetching Smartnode Locked Coins:', error);
      throw error;
  }
};

export const fetchTopAddresses = async () => {
  try {
    const response = await axios.get(`${API_BASE_URL}/top-addresses`);
    return response.data;
  } catch (error) {
    console.error('Error fetching top addresses:', error);
    return null;
  }
};

export const fetchAddressTransactions = async (address, page) => {
  try {
    const response = await axios.get(`${API_BASE_URL}/transactions/${address}`, {
      params: { page },
    });
    return response.data.results;
  } catch (error) {
    console.error('Error fetching address transactions:', error);
    throw new Error('No se pudieron obtener las transacciones de la dirección.');
  }
};

export const claimAddress = async (address, displayName, signature, url) => {
  try {
    console.log('Sending data:', { address, displayName, signature, url });

    const response = await axios.post(`${API_BASE_URL}/claim-address`, {
      address,
      displayName,
      signature,
      url: url || null, 
    });

    console.log('Response data:', response.data);
    return response.data;
  } catch (error) {
    console.error('Error claiming address:', error);
    throw error.response?.data?.error || 'An error occurred while claiming the address.';
  }
};

export const fetchSmartnodeLockedCoins = async () => {
  try {
    const response = await axios.get(`${API_BASE_URL}/getSmartnodeLockedCoins`);
    return response.data; 
  } catch (error) {
    console.error('Error fetching Smartnode locked coins:', error);
    return null;
  }
};

export const fetchSupply = async () => {
  try {
    const response = await axios.get(`${API_BASE_URL}/supply`);
    return response.data;
  } catch (error) {
    console.error('Error fetching supply data:', error);
    return null;
  }
};

export const fetchLatestBlocksSummary = async () => {
  try {
    const response = await axios.get(`${API_BASE_URL}/latest-blocks-summary`);
    return response.data;
  } catch (error) {
    console.error('Error fetching latest blocks summary:', error);
    return [];
  }
};

export const fetchNetworkStats = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/getNetworkStats`);
      return response.data;
    } catch (error) {
      console.error('Error fetching network stats:', error);
      return null;
    }
};

export const fetchBlockByHash = async (blockHash) => {
    try {
      const response = await axios.get(`${API_BASE_URL}/block-hash/${blockHash}`);
      return response.data;
    } catch (error) {
      if (error.response) {
        console.error(`Error Response Data:`, error.response.data);
        console.error(`Error Status:`, error.response.status);
      } else if (error.request) {
        console.error('No response received:', error.request);
      } else {
        console.error('Error setting up request:', error.message);
      }
      return null;
    }
};
  
export const fetchLastBlocks = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/last-blocks`);
      return response.data;
    } catch (error) {
      console.error('Error fetching last blocks:', error);
      return [];
    }
};
  
export const fetchSmartnodeData = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/getSmartnodeData?includeSummary=true&includeList=true`);
      return response.data;
    } catch (error) {
      console.error('Error fetching smartnode data:', error);
      return null;
    }
};
////////////////////////////////////////////////
export const fetchGeolocateIP = async (ip) => {
  try {
    // Ejemplo usando ipapi.co
    const response = await axios.get(`https://ipapi.co/${ip}/json/`);
    return {
      countryCode: response.data.country_code, // p. ej. "US", "ES", "MX"
      countryName: response.data.country_name, // p. ej. "United States"
    };
  } catch (error) {
    console.error(`Error geolocating IP ${ip}:`, error);
    return { countryCode: null, countryName: null };
  }
};

export const fetchPeerInfo = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/getpeerinfo`);
      return response.data;
    } catch (error) {
      console.error('Error fetching peer info:', error);
      return [];
    }
};
/////////////////////////////////////////////
export const fetchBlockByHeight = async (blockHeight) => {
    try {
      const response = await axios.get(`${API_BASE_URL}/block-height/${blockHeight}`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching block by height (${blockHeight}):`, error);
      return null;
    }
  };
  
export const fetchTransactionByTxid = async (txid) => {
    try {
      const response = await axios.get(`${API_BASE_URL}/txid/${txid}`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching transaction by txid (${txid}):`, error);
      return null;
    }
};

export const fetchInputAddresses = async (txid) => {
    try {
      const response = await axios.get(`${API_BASE_URL}/ext/tx/${txid}`);
      return response.data.input_addresses;
    } catch (error) {
      console.error(`Error fetching input addresses for txid (${txid}):`, error);
      return [];
    }
};
  
export const fetchHighestPriceExchange = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/prices`);
      const prices = response.data;
  
      if (!prices || prices.length === 0) {
        return null;
      }
      // el precio más alto
      const highestPriceExchange = prices.reduce((max, exchange) =>
        parseFloat(exchange.last_price) > parseFloat(max.last_price) ? exchange : max
      );
      return highestPriceExchange;
    } catch (error) {
      console.error('[ERROR] No se pudo obtener los precios:', error);
      return null;
    }
};

export const checkTxid = async (txid) => {
  try {
    const response = await axios.get(`${API_BASE_URL}/txid/${txid}`);
    return response.data.error ? null : 'txid';
  } catch {
    return null;
  }
};

export const checkBlockHash = async (hash) => {
  try {
    const response = await axios.get(`${API_BASE_URL}/block-hash/${hash}`);
    return response.data.error ? null : 'block-hash';
  } catch {
    return null;
  }
};
